document.addEventListener('DOMContentLoaded', () => {
    // --- 1. READ MORE / EXPAND LOGIC ---
    const initReadMore = () => {
        const reviewCards = document.querySelectorAll('.google-review-card');

        reviewCards.forEach((card) => {
            const reviewText = card.querySelector('.google-review-card__review');
            const readMoreBtn = card.querySelector('.g-read-more');

            if (!reviewText || !readMoreBtn) return;

            // Use clientHeight for exact comparison (155px)
            const isOverflowing = reviewText.scrollHeight > reviewText.clientHeight;

            if (isOverflowing) {
                readMoreBtn.style.display = 'inline-block';
                reviewText.classList.add('has-overflow'); // Tells CSS to enable the gradient fade
            } else {
                readMoreBtn.style.display = 'none';
                reviewText.classList.remove('has-overflow'); // Ensures gradient stays hidden (fixes Pietro's card)
            }

            readMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();

                const isExpanded = reviewText.classList.toggle('is-expanded');

                if (isExpanded) {
                    reviewText.style.height = `${reviewText.scrollHeight}px`;
                    readMoreBtn.textContent = readMoreBtn.dataset.readLess;
                } else {
                    reviewText.style.height = '155px';
                    readMoreBtn.textContent = readMoreBtn.dataset.readMore;
                }
            });
        });
    };
    // --- 2. CAROUSEL BUTTONS & DRAG LOGIC ---
    const initCarousel = () => {
        const carousels = document.querySelectorAll('.g-reviews-carousel');

        carousels.forEach((carousel) => {
            const viewport = carousel.querySelector('.g-reviews-viewport');
            const prevBtn = carousel.querySelector('button.prev');
            const nextBtn = carousel.querySelector('button.next');

            if (!viewport) return;

            // Prev/Next Button Controls
            const getScrollAmount = () => viewport.clientWidth * 0.75;

            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    viewport.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
                });
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    viewport.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
                });
            }

            // Drag Left / Right Logic
            let isDragging = false;
            let startX = 0;
            let scrollLeft = 0;

            const startDrag = (e) => {
                isDragging = true;
                viewport.classList.add('is-dragging');
                startX = (e.pageX || e.touches[0].pageX) - viewport.offsetLeft;
                scrollLeft = viewport.scrollLeft;
            };

            const stopDrag = () => {
                isDragging = false;
                viewport.classList.remove('is-dragging');
            };

            const moveDrag = (e) => {
                if (!isDragging) return;
                e.preventDefault();
                const x = (e.pageX || e.touches[0].pageX) - viewport.offsetLeft;
                const walk = (x - startX) * 1.5; // Drag speed multiplier
                viewport.scrollLeft = scrollLeft - walk;
            };

            // Mouse events
            viewport.addEventListener('mousedown', startDrag);
            viewport.addEventListener('mouseleave', stopDrag);
            viewport.addEventListener('mouseup', stopDrag);
            viewport.addEventListener('mousemove', moveDrag);

            // Prevent link navigation during intentional drag
            viewport.addEventListener('click', (e) => {
                if (viewport.classList.contains('was-dragged')) {
                    e.preventDefault();
                    viewport.classList.remove('was-dragged');
                }
            });
        });
    };

    initReadMore();
    initCarousel();
});